import { keepPreviousData, useQuery } from "@tanstack/react-query";

import { MissionsParams, getMissions } from "../../services/productPlaneApi";
import { queryKeys } from "./keys";

const STALE_TIME = 60 * 1000;
const GC_TIME = 5 * 60 * 1000;

/**
 * TanStack Query hook for one capability at the centre of a selection of
 * products: what goes with it and who provides it.
 *
 * The caller builds the request from the selection and the view's settings.
 * Uses `keepPreviousData` so the rings stay drawn while a change of chips
 * loads. A centre that is no capability pick, or an unknown qualifier, fails
 * with a 404, which is not retried.
 */
export function useMissions(params: MissionsParams, enabled = true) {
  return useQuery({
    queryKey: queryKeys.productPlane.missions(params),
    queryFn: () => getMissions(params),
    enabled,
    staleTime: STALE_TIME,
    gcTime: GC_TIME,
    placeholderData: keepPreviousData,
    retry: (count, error) =>
      (error as { response?: { status?: number } } | null)?.response?.status !==
        404 && count < 2,
  });
}
